import {
  LEARN_CALENDAR_SLUG,
  LEARN_CATALOG_SLUG,
  LEARN_DASHBOARD_SLUG,
  LEARN_EMAIL_ANSWER_SLUG,
  LEARN_MY_COURSES_SLUG,
} from '@/features/layout/LayoutMain/constants'
import { useStencilNavigation } from '../useStencilNavigation'

export const useShouldShowSidebar = () => {
  const { activeSlug } = useStencilNavigation()

  const isCatalog = activeSlug === LEARN_CATALOG_SLUG
  const isMyCourses = activeSlug === LEARN_MY_COURSES_SLUG
  const isDashboard = activeSlug === LEARN_DASHBOARD_SLUG
  const isCalendar = activeSlug === LEARN_CALENDAR_SLUG
  const isKMEmailResponse = activeSlug === LEARN_EMAIL_ANSWER_SLUG

  return isCatalog || isMyCourses || isDashboard || isCalendar || isKMEmailResponse
}
